export default {
	title: {
		inner: 'Kino, Mond & Sterne',
    separator: ' ',
    complement: ''
	},
	// Meta tags
	meta: [
	  { name: 'application-name', content: 'Kino, Mond & Sterne – das Open-Air-Kino im Westpark München' },
	  { name: 'description', content: 'Bei Kino, Mond & Sterne, dem beliebten Open-Air-Kino im Münchener Westpark, wird der Kinobesuch zu einem unvergesslichen Filmerlebnis unterm Sternenhimmel.', id:'desc' }, // id to replace intead of create element
	  // ...
	  // Twitter
	  { name: 'twitter:title', content: 'Kino, Mond & Sterne – das Open-Air-Kino im Westpark München' },
	  { name: 'twitter:description', content: 'Bei Kino, Mond & Sterne, dem beliebten Open-Air-Kino im Münchener Westpark, wird der Kinobesuch zu einem unvergesslichen Filmerlebnis unterm Sternenhimmel.'},
	  // ...
	  // Facebook / Open Graph
	  //{ property: 'fb:app_id', content: '123456789' },
	  { property: 'og:title', content: 'Kino, Mond & Sterne – das Open-Air-Kino im Westpark München' },
		{ property: 'og:description', content: 'Bei Kino, Mond & Sterne, dem beliebten Open-Air-Kino im Münchener Westpark, wird der Kinobesuch zu einem unvergesslichen Filmerlebnis unterm Sternenhimmel.' },
	  // ...
		//Android Theme
		{ name: 'theme-color', content: '#0B1827'},
		//ms Theme
		{ name: 'msapplication-TileColor', content: '#0B1827'}
	],
	// link tags
	link: [
	  //{ rel: 'canonical', href: 'https://KMS-default domain/', id: 'canonical' },
	  { rel: 'author', href: 'https://coma.de', undo: false }, // undo property - not to remove the element
	  { rel: 'icon', href: '/static/img/favicon/favicon-16x16.png', sizes: '16x16', type: 'image/png' },
		{ rel: 'icon', href: '/static/img/favicon/favicon-32x32.png', sizes: '32x32', type: 'image/png' },
		{ rel: 'apple-touch-icon', href: '/static/img/favicon/apple-touch-icon.png', sizes: '180x180', type: 'image/png' },
		{ rel: 'manifest', href: '/site.webmanifest', crossorigin:'use-credentials'},
		{ rel: 'mask-icon', href: '/static/img/favicon/safari-pinned-tab.svg', color: '#0b1827'},
	  // ...
	],
	script: [
	  //{ type: 'text/javascript', src: 'cdn/to/script.js', async: true, body: true}, // Insert in body
	  // ...
	],
	style: [
	  //{ type: 'text/css', inner: 'body { background-color: #000; color: #fff}', undo: false },
	  // ...
	]
}



// WEBPACK FOOTER //
// ./src/config/defaultHeader.js